import {http} from '@/utils';

export type NewUserRankTypeParams = {
  group: 0;
  pageNo: number;
  pageSize: number;
  date: string;
};
export type NewUserRankTypeResponse = {
  rank: number;
  userId: string;
  username: string;
  userPhone: string;
  totalScore: number;
  rewardValue: number;
  userAvatar: string;
}[];
export type GetJackpotParams = {
  date: string;
};

export type GetJackpotResponse = number;

export type GetUserRankParams = {
  date: string;
};

export type GetUserRankResponse = {
  rank: number;
  userId: string;
  username: string;
  userPhone: string;
  totalScore: number;
  rewardValue: number;
  userAvatar: string;
};

// 获取用户下注排行
export async function getDailyNewUserRanking(
  params: Partial<NewUserRankTypeParams>,
) {
  try {
    return await http.post<NewUserRankTypeParams, NewUserRankTypeResponse>(
      '/app/newUserRank/getRank',
      params,
    );
  } catch (err) {
    return [] as NewUserRankTypeResponse;
  }
}

// 下注奖金
export async function getJackpot(params: GetJackpotParams) {
  try {
    return await http.post<GetJackpotParams, GetJackpotResponse>(
      '/app/newUserRank/getJackpot',
      params,
    );
  } catch (err) {
    return 0.0 as GetJackpotResponse;
  }
}

// 当前用户的排行
export async function getUserRank(params: GetUserRankParams) {
  try {
    return await http.post<GetUserRankParams, GetUserRankResponse>(
      '/app/newUserRank/getUserRank',
      params,
    );
  } catch (err) {
    return {
      rank: 0,
      userId: '',
      username: '',
      userPhone: '',
      totalScore: 0.0,
      rewardValue: 0.0,
    } as GetUserRankResponse;
  }
}

// 获取昨日获取的金额
export async function getYesterdayReward() {
  const res = await http.post<
    any,
    {
      activityName: string;
      betScore: number;
      hasReward: boolean;
      inviteScore: number;
      rankPosition: number;
      rewardDate: number;
      rewardStatus: number;
      rewardValue: number;
      totalScore: number;
      userId: string;
      userPhone: string;
      inviteCount: number;
    }
  >('/app/newUserRank/getYesterdayReward');
  return {
    reward: res.rewardValue || 0,
    hasRank: res.hasReward,
    hasReward: res.hasReward,
    rank: res.rankPosition,
    inviteScore: res.inviteScore || 0,
    inviteCount: res.inviteCount || 0,
  };
}
